var types_HeadingTypes = /*#__PURE__*/ function(HeadingTypes) {
    HeadingTypes["h1"] = "h1";
    HeadingTypes["h2"] = "h2";
    HeadingTypes["h3"] = "h3";
    HeadingTypes["h4"] = "h4";
    HeadingTypes["h5"] = "h5";
    HeadingTypes["h6"] = "h6";
    return HeadingTypes;
}({});
var types_HeadingSize = /*#__PURE__*/ function(HeadingSize) {
    HeadingSize["displayLarge"] = "ptw-text-display-lg";
    HeadingSize["dislayMedium"] = "ptw-text-display-md";
    HeadingSize["dislaySmall"] = "ptw-text-display-sm";
    HeadingSize["titleLarge"] = "ptw-text-title-lg";
    HeadingSize["titleMedium"] = "ptw-text-title-md";
    HeadingSize["titleSmall"] = "ptw-text-title-sm";
    return HeadingSize;
}({});
var types_HeadingWeight = /*#__PURE__*/ function(HeadingWeight) {
    HeadingWeight["heavy"] = "ptw-font-extrabold";
    HeadingWeight["bold"] = "ptw-font-semibold";
    HeadingWeight["regular"] = "ptw-font-normal";
    HeadingWeight["light"] = "ptw-font-extralight";
    return HeadingWeight;
}({});
export { types_HeadingSize as HeadingSize, types_HeadingTypes as HeadingTypes, types_HeadingWeight as HeadingWeight };
